import { render, staticRenderFns } from "./page-field.vue?vue&type=template&id=a6f3023a&scoped=true&"
import script from "./page-field.vue?vue&type=script&lang=js&"
export * from "./page-field.vue?vue&type=script&lang=js&"
import style0 from "./page-field.vue?vue&type=style&index=0&id=a6f3023a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f3023a",
  null
  
)

export default component.exports